module.exports = __webpack_public_path__ + "static/media/POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES.d4dc8d33.pdf";